const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-configs",
    meta: {},
    name: "m-configs",
    component: () => import("@/modules/mconfigs/RootView.vue")
});

export default Routes;